// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function () {
	this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(document).ready(function() {
	$(window).resize(function () {
		Breakpoint.refreshValue();
	}).resize();
});


// Libs
import PubSub from "underpub-js";
import Sitewide from "./classes/Sitewide";
import ComponentsLoader from "./classes/ComponentsLoader";
import Analytics from "./classes/Analytics";

// Components Import -- DO NOT REMOVE COMMENT!
import FloorplanCategoryHeader from "../../templates/_components/molecules/FloorplanCategoryHeader/FloorplanCategoryHeader";
import Breadcrumb from "../../templates/_components/elements/Breadcrumb/Breadcrumb";
import AvailabilityTabs from "../../templates/_components/molecules/AvailabilityTabs/AvailabilityTabs";
import ModalsContainer from "../../templates/_components/layouts/ModalsContainer/ModalsContainer";
import BannersContainer from "../../templates/_components/layouts/BannersContainer/BannersContainer";
import Modal from "../../templates/_components/molecules/Modal/Modal";
import PrimaryNavigationLinks from "../../templates/_components/elements/PrimaryNavigationLinks/PrimaryNavigationLinks";
import Availability from "../../templates/_components/layouts/Availability/Availability";
import PopupPlace from "../../templates/_components/elements/PopupPlace/PopupPlace";
import PopupItem from "../../templates/_components/elements/PopupItem/PopupItem";
import PopupUnit from "../../templates/_components/elements/PopupUnit/PopupUnit";
import TableListItem from "../../templates/_components/elements/TableListItem/TableListItem";
import FloorplanCard from "../../templates/_components/elements/FloorplanCard/FloorplanCard";
import CtaForm from "../../templates/_components/molecules/CtaForm/CtaForm";
import MapPoi from "../../templates/_components/molecules/MapPoi/MapPoi";
import MapStandard from "../../templates/_components/molecules/MapStandard/MapStandard";
import MapHotspots from "../../templates/_components/molecules/MapHotspots/MapHotspots";
import AvailabilityMap from "../../templates/_components/molecules/AvailabilityMap/AvailabilityMap";
import AvailabilityTable from "../../templates/_components/molecules/AvailabilityTable/AvailabilityTable";
import FloorplanHeader from "../../templates/_components/molecules/FloorplanHeader/FloorplanHeader";
import FloorplanListing from "../../templates/_components/molecules/FloorplanListing/FloorplanListing";
import BannerButton from "../../templates/_components/molecules/BannerButton/BannerButton";
import BannerSimple from "../../templates/_components/molecules/BannerSimple/BannerSimple";
import ResponsiveImage from "../../templates/_components/atoms/Media/ResponsiveImage/ResponsiveImage";
import BreakpointIndicator from "../../templates/_components/atoms/Global/BreakpointIndicator/BreakpointIndicator";
import Form from "../../templates/_components/elements/Forms/Form/Form";


window.Webflow ||= [];
window.Webflow.push(() => {

	console.log("Webflow initialized and DOM ready");

	// ✅ Place all your custom jQuery/JS here
	$('.my-button').on('click', function () {
		console.log('Button clicked!');
	});

	// Or manipulate Webflow-generated elements safely here

	var components = [
		// Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".mol-FloorplanCategoryHeader", require: FloorplanCategoryHeader },
{handle: ".el-Breadcrumb", require: Breadcrumb },
{handle: ".mol-AvailabilityTabs", require: AvailabilityTabs },
{handle: ".layout-ModalsContainer", require: ModalsContainer },
{handle: ".layout-BannersContainer", require: BannersContainer },
{handle: ".mol-Modal", require: Modal },
{handle: ".el-PrimaryNavigationLinks", require: PrimaryNavigationLinks },
{handle: ".layout-Availability", require: Availability },
{handle: ".el-PopupPlace", require: PopupPlace },
{handle: ".el-PopupItem", require: PopupItem },
{handle: ".el-PopupUnit", require: PopupUnit },
{handle: ".el-TableListItem", require: TableListItem },
{handle: ".el-FloorplanCard", require: FloorplanCard },
{handle: ".mol-CtaForm", require: CtaForm },
{handle: ".mol-MapPoi", require: MapPoi },
{handle: ".mol-MapStandard", require: MapStandard },
{handle: ".mol-MapHotspots", require: MapHotspots },
{handle: ".mol-AvailabilityMap", require: AvailabilityMap },
{handle: "[data-amp-component=\"AvailabilityTable\"]", require: AvailabilityTable },
{handle: ".mol-FloorplanHeader", require: FloorplanHeader },
{handle: ".mol-FloorplanListing", require: FloorplanListing },
{handle: ".mol-BannerButton", require: BannerButton },
{handle: ".mol-BannerSimple", require: BannerSimple },
		// Atoms
		{handle: ".atom-ResponsiveImage", require: ResponsiveImage },
		{handle: ".atom-BreakpointIndicator", require: BreakpointIndicator },
		
		// Elements
		{handle: ".el-Form", require: Form }
	];

	var sitewide = new Sitewide();
	sitewide.init();

	// Getting our components loading going
	window.componentsLoader = new ComponentsLoader({
		components: components
	});
	window.componentsLoader.initScreen();

	// Initialize modal triggers after components are loaded
	Modal.initTriggers();

	// kick off Analytics
	var analytics = new Analytics();
	analytics.init();  

	// setting our breakpoint value
	Breakpoint.refreshValue();

});